import { render, staticRenderFns } from "./FormSix.vue?vue&type=template&id=24850a92&scoped=true"
import script from "./FormSix.vue?vue&type=script&lang=js"
export * from "./FormSix.vue?vue&type=script&lang=js"
import style0 from "./FormSix.vue?vue&type=style&index=0&id=24850a92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24850a92",
  null
  
)

export default component.exports